import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as GuestListActions } from '../constants/GuestListConstants';
import { actions as UserActions } from '../constants/UserConstants';

import { events as GuestListEvents } from '../constants/GuestListConstants';

var _state = {
    guestList      : [],
    searchResults  : [],
    statusList     : [],
    sortByLastName : false,
    showSearchBar  : true,
    showGuestAssignedToRegister : true,
    page: 'location',
    defaultStatus: null,
    transactionId: null,
    guest: null,
    pusherConnected: false
};

class GuestListStoreClass extends EventEmitter {

    getState() {
        return _state;
    }

    getGuestById(user_id) {
        for (var i=0; i<_state.guestList.length; i++) {
            if (_state.guestList[i].Guest_id === user_id)
                return _state.guestList[i];
        }

        return false;
    }

    replaceGuest(guest) {
        for (var i=0; i<_state.guestList.length; i++) {
            if (_state.guestList[i].Guest_id === guest.Guest_id)
                _state.guestList[i] = guest;
        }
    }

    setPage(page) {
        _state.page = page;
        this.emitPageChange();
    }

    setGuest(guest) {
        _state.guest = guest;
        this.emitPageChange();
    }

    setTransactionId(transactionId) {
        _state.transactionId = transactionId;
        this.emitPageChange();
    }

    emitChange( callback ) {
        this.emit(GuestListEvents.CHANGE_EVENT, callback)
    }

    emitPageChange(x) {
        this.emit(GuestListEvents.PAGE_CHANGE, x);
    }

    addChangeListener( callback ) {
        this.on(GuestListEvents.CHANGE_EVENT, callback)
    }

    addPageChangeListener(x) {
        this.on(GuestListEvents.PAGE_CHANGE, x);
    }

    removeChangeListener( callback ) {
        this.removeListener(GuestListEvents.CHANGE_EVENT, callback)
    }

    emitSearch( callback ) {
        this.emit(GuestListEvents.SEARCH_EVENT, callback)
    }

    addSearchListener( callback ) {
        this.on(GuestListEvents.SEARCH_EVENT, callback)
    }

    removeSearchListener( callback ) {
        this.removeListener(GuestListEvents.SEARCH_EVENT, callback)
    }
}

const GuestListStore = new GuestListStoreClass();

GuestListStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {

        case GuestListActions.GUEST_LIST_LOADED:
            _state.guestList = action.data ? action.data : [];
            GuestListStore.emitChange();
            break;

        case GuestListActions.SEARCH_RESULTS:
            _state.searchResults = action.data;
            GuestListStore.emitSearch();
            break;

        case GuestListActions.TOGGLE_SEARCH_BAR:
            _state.showSearchBar = action.data;
            GuestListStore.emitChange();
            break;

        case GuestListActions.TOGGLE_GUEST_ASSIGNED_TO_REGISTER:
            _state.showGuestAssignedToRegister = action.data;
            GuestListStore.emitChange();
            break;

        case UserActions.SELECT_LOCATION:
            _state.sortByLastName = action.data.selectedLocation.SortByLastName;
            _state.showSearchBar  = action.data.selectedLocation.ShowSearchBar;
            GuestListStore.emitChange();
            break;

        case GuestListActions.STATUS_LIST_LOADED:
            _state.statusList = action.data.statuses;
            _state.defaultStatus = action.data.default;
            GuestListStore.emitChange();
            break;
        case GuestListActions.GUEST_NOTIFICATION_GROUP_JOINED:
            _state.pusherConnected = true;
            GuestListStore.emitChange();
            break;
        case GuestListActions.NOTIFY_CONNECTION_LOST:
            _state.pusherConnected = false;
            GuestListStore.emitChange();
            break;    
    }
});

export default GuestListStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/GuestListStore.jsx